import { useState } from 'react'
import { FaArrowUp, FaArrowDown, FaSortAmountUp, FaSortAmountDown } from 'react-icons/fa'
import styles from '@/components/directory/v2/card-view/EVsCardItemVariantsHeaderComponent.module.css'

const EVsCardItemVariantsHeaderComponent = ({ onSort }) => {
  const [sortConfig, setSortConfig] = useState({ key: 'year', direction: 'ascending' })

  const handleSort = (key) => {
    let direction = 'ascending'
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending'
    }
    setSortConfig({ key, direction })
    onSort({ key, direction })
  }

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return null
    return sortConfig.direction === 'ascending' ? <FaArrowUp /> : <FaArrowDown />
  }

  return (
    <div className={styles.header}>
      <div className={styles.attributes}>
        <div className={styles.attribute} onClick={() => handleSort('year')}>
          <span>Release Year</span> <span>{renderSortIcon('year')}</span>
        </div>
        <div className={styles.attribute} onClick={() => handleSort('capacity')}>
          <span>Total Battery Capacity</span> <span>{renderSortIcon('capacity')}</span>
        </div>
        <div className={styles.attribute} onClick={() => handleSort('status')}>
          <span>Status</span> <span>{renderSortIcon('status')}</span>
        </div>
        {/*<div className={styles.attribute} onClick={() => handleSort('price')}>
          <span>Price When New</span> <span>{renderSortIcon('price')}</span>
        </div>*/}
        <div className={styles.attribute} onClick={() => handleSort('range')}>
          <span>Avg New Range</span> <span>{renderSortIcon('range')}</span>
        </div>
        <div className={styles.attribute} onClick={() => handleSort('charge_time')}>
          <span>Fastest Charge Time</span> <span>{renderSortIcon('charge_time')}</span>
        </div>
        <div className={styles.attribute} onClick={() => handleSort('speed')}>
          <span>0-62 MPH</span> <span>{renderSortIcon('speed')}</span>
        </div>
      </div>
    </div>
  )
}

export default EVsCardItemVariantsHeaderComponent
